import { CardTypes } from 'types/constants';
import CardsIconItem from '../CardsIcon/CardsIconItem';
import CardsImageItem from '../CardsImage/CardsImageItem';

// types
import { ExtendedCardType, CardIconItem, CardImageItem } from './types';

export type CardProps = {
  card: ExtendedCardType;
  index: number;
  total: number;
  cardStyle: string;

  testId?: string;
};

// predicates for resolving the
const isCardsIconPredicate = (card: ExtendedCardType): card is CardIconItem =>
  (card as CardIconItem).__typename === CardTypes.Icon;
const isCardsImagePredicate = (card: ExtendedCardType): card is CardImageItem =>
  (card as CardImageItem).__typename === CardTypes.Image;

const Card = ({ card, testId, ...props }: CardProps) => {
  const testFixture = `${testId ?? 'card'}-item`;

  return (
    <>
      {isCardsIconPredicate(card) ? <CardsIconItem {...card} {...props} testId={testFixture} /> : null}
      {isCardsImagePredicate(card) ? <CardsImageItem {...card} {...props} testId={testFixture} /> : null}
    </>
  );
};

export default Card;
